import {
  IonButton,
  IonCol,
  IonContent,
  IonLoading,
  IonPage,
  IonRow,
  useIonRouter,
} from '@ionic/react'

import { useAccount } from '../../../contexts/authContext'
import { PhoneKeypadInput } from '../../../components/ui/phone-keypad-input'
import { RotateInfoContainer } from '../../../rotate/components/rotate-info-container'
import { RotateInfoIntro } from '../../../rotate/components/rotate-info-intro'
import { RotateInfoLegal } from '../../../rotate/components/rotate-info-legal'
import { usePhoneCheckIn } from '../../../check-in/utils'
import { CheckInWrapper } from '../../../check-in/components/check-in-wrapper'

function PairedPhoneCheckInPage() {
  const account = useAccount()
  const checkInSettings = account.account.checkInSettings

  const router = useIonRouter()
  const { error, handleCheckIn, isLoading } = usePhoneCheckIn({
    addCustomerRedirect: '/check-in/paired/add-customer',
    loyaltyRedirect: '/check-in/paired/loyalty-info',
  })

  return (
    <IonPage>
      <IonContent>
        <CheckInWrapper>
          <IonRow className="h-full">
            <IonCol size="6">
              <RotateInfoContainer>
                <IonButton
                  disabled={isLoading}
                  fill="solid"
                  color="secondary"
                  onClick={() =>
                    router.push(
                      `/check-in/paired/email-check-in`,
                      'none',
                      'replace'
                    )
                  }
                >
                  Check-In With Email
                </IonButton>

                <div className="w-full self-center text-center">
                  {checkInSettings?.body?.text ? (
                    <RotateInfoIntro>
                      {checkInSettings?.body?.text}
                    </RotateInfoIntro>
                  ) : null}
                  <p className="text-ion-color-danger">{error}</p>
                </div>
                <RotateInfoLegal />
              </RotateInfoContainer>
            </IonCol>
            <IonCol
              size="6"
              className="flex h-full flex-1 flex-col items-center justify-center"
            >
              <PhoneKeypadInput
                disabled={isLoading}
                onConfirm={(e) => handleCheckIn({ ...e, autoOptIn: true })}
                altLabel="Check-In"
              />
            </IonCol>
          </IonRow>
        </CheckInWrapper>
      </IonContent>
      <IonLoading
        isOpen={isLoading}
        message="Hold tight, we are checking you in!"
      />
    </IonPage>
  )
}

export { PairedPhoneCheckInPage }
